/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A terminal status outcome, independent of its tenant-specific display name.
 */
export enum FunnelStatusTerminalOutcome {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
}
